/**
 * Month helpers for the store credit ledger page. Dates only: the figures and the
 * totals always come from Prism.
 */

const MONTH_PATTERN = /^(\d{4})-(0[1-9]|1[0-2])$/

/** "2026-11" for the current local month. */
export function thisMonth(now = new Date()) {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
}

/** First and last day of a "YYYY-MM" month as YYYY-MM-DD, both inclusive. */
export function monthRange(month) {
  const match = MONTH_PATTERN.exec(month || '')
  if (!match) throw new Error(`Not a month: ${month}`)
  const year = Number(match[1])
  const monthNumber = Number(match[2])
  const lastDay = new Date(Date.UTC(year, monthNumber, 0)).getUTCDate()
  return { from: `${month}-01`, to: `${month}-${String(lastDay).padStart(2, '0')}` }
}

export function csvFileName(month) {
  return `store-credit-ledger-${month}.csv`
}
